import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from '../../helpers/BaseError';

import {
    FormulaTestMessageRequestParams,
    FormulaTestMessageRequestParamsV2,
    FormulaTestMessageResponse,
} from '../../models/formula.model';

import API from '../../services/api';

const useSendFormulaTestMessageMutation = (formulaId: number) => {
    return useMutation<
        AxiosResponse<FormulaTestMessageResponse>,
        BaseError,
        FormulaTestMessageRequestParams
    >({
        mutationFn: (data: FormulaTestMessageRequestParams) =>
            API.sendFormulaTestMessage(formulaId, { ...data }),
    });
};
export default useSendFormulaTestMessageMutation;

export const useSendFormulaTestMessageV2Mutation = (formulaId: number) => {
    return useMutation<
        AxiosResponse<FormulaTestMessageResponse>,
        BaseError,
        FormulaTestMessageRequestParamsV2
    >({
        mutationFn: (data: FormulaTestMessageRequestParamsV2) =>
            API.sendFormulaTestMessageV2(formulaId, { ...data }),
    });
};
